import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Typography from "@material-ui/core/Typography";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import Button from "@material-ui/core/Button";
import AutoForm from "react-auto-form";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

//import { ToastContainer, toast } from "react-toastify";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export class O_MonitoringNoteWorks extends Component {
    ////constructor(props) {
    ////    super(props);
    ////    this.state = {
    ////        lastOnChange: null,
    ////        lastOnSubmit: null,
    ////        trim: true,
    ////        trimOnSubmit: false
    ////    };
    ////}

    ////_onChange = (e, name, data, change) => {
    ////    console.log(data);
    ////    this.setState({ lastOnChange: { name, data, change } });
    ////};

    ////_onSubmit = (e, data) => {
    ////    console.log("submit");
    ////    console.log(data);
    ////    this.setState({ lastOnSubmit: { data } });
    ////    e.preventDefault();
    ////};

    ////_onOptionsChange = (e, name, data, change) => {
    ////    this.setState(change);
    ////};

    //constructor(props) {
    //    super(props);
    //    this.state = {
    //        projectId: props.propProjectId,
    //        lastOnChange: null,
    //        lastOnSubmit: null,
    //        trim: true,
    //        trimOnSubmit: false,
    //        pageLoadData: {}
    //    };
    //}

    //_onChange = (e, name, data, change) => {
    //    console.log(data);
    //    this.setState({ lastOnChange: { name, data, change } });
    //};

    //_onSubmit = (e, data) => {
    //    console.log("submit");
    //    //console.log(data);
    //    this.setState({ lastOnSubmit: { data } });

    //    let dataToSubmit = data;
    //    dataToSubmit["projectId"] = this.state.projectId;
    //    dataToSubmit["templateId"] = 4;
    //    console.log(dataToSubmit);

    //    fetch(global.variables.API_TEMPLATEFILLER_FILLANSWERS, {
    //        method: "POST",
    //        headers: {
    //            Authorization: "Bearer " + localStorage.getItem("authtoken"),
    //            Accept: "application/json",
    //            "Content-Type": "application/json"
    //        },
    //        body: JSON.stringify(dataToSubmit)
    //    })
    //        .then(response => response.json())
    //        .then(result => {
    //            console.log(result);
    //        });

    //    e.preventDefault();
    //};

    //_onOptionsChange = (e, name, data, change) => {
    //    console.log(data);
    //    this.setState(change);
    //};

    //async componentDidMount() {
    //    await fetch(global.variables.API_TEMPLATEFILLER_GETANSWERS, {
    //        method: "POST",
    //        headers: {
    //            Authorization: "Bearer " + localStorage.getItem("authtoken"),
    //            Accept: "application/json",
    //            "Content-Type": "application/json"
    //        },
    //        body: JSON.stringify({
    //            operation: "GetOnGoingMNoteWorks",
    //            projectId: this.state.projectId,
    //            templateId: 4
    //        })
    //    })
    //        .then(response => response.json())
    //        .then(result => {
    //            console.log(result);

    //            if (result.saveddata.length > 0) {
    //                this.setState({ pageLoadData: JSON.parse(result.saveddata[0].TemplateAnswers) });
    //            }
    //        });

    //    //console.log(this.state.pageLoadData);
    //    //console.log(this.state.pageLoadData.OmrQ1Context);
    //    //this.forceUpdate();
    //}

    //render() {
    //    //let { lastOnChange, lastOnSubmit, trim, trimOnSubmit } = this.state;
    //    let { trim, trimOnSubmit } = this.state;


    constructor(props) {
        super(props);
        this.state = {
            missionId: props.propMissionId,
            lastOnChange: null,
            lastOnSubmit: null,
            trim: false,
            trimOnSubmit: false,
            pageLoadData: {},
            templateId: props.propTemplateId,
            countOtherDocuments: 1,
            countPerson: 1,
            interviewPersonCategories: [
                { TypeId: 1, TypeName: "Beneficiary" },
                { TypeId: 2, TypeName: "Partner Country" },
                { TypeId: 3, TypeName: "Stakeholder" },
                { TypeId: 4, TypeName: "Other" },
                { TypeId: 5, TypeName: "DEUA" },
                { TypeId: 6, TypeName: "EU Delegation" },
                { TypeId: 7, TypeName: "Contracting Authority" },
                { TypeId: 8, TypeName: "End Beneficiary" },
                { TypeId: 9, TypeName: "Lead Institution" },
                { TypeId: 10, TypeName: "Contractor" },
                { TypeId: 11, TypeName: "Final Beneficiary" },
            ],
        };
    }

    _onChange = (e, name, data, change) => {
        console.log(data)

        var pageLoadDataChange = this.state.pageLoadData;
        pageLoadDataChange[name] = data;

        this.setState({
            lastOnChange: { name, data, change },
            pageLoadData: pageLoadDataChange
        });

    }

    _onSubmit = (e, data) => {
        console.log("submit");
        this.setState({ lastOnSubmit: { data } });

        let dataToSubmit = data;
        dataToSubmit["missionId"] = this.state.missionId;
        dataToSubmit["templateId"] = this.state.templateId;
        dataToSubmit["countOtherDocuments"] = this.state.countOtherDocuments;
        dataToSubmit["countPerson"] = this.state.countPerson;
        console.log(dataToSubmit);

        this.props.propUpdatePageLoadData(dataToSubmit);

        fetch(global.variables.API_TEMPLATEFILLER_FILLANSWERS, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(dataToSubmit)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 0) {
                    toast.success("Success!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                } else {
                    toast.error("Failed!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }
            });

        e.preventDefault();
    }

    _onOptionsChange = (e, name, data, change) => {
        console.log(data);
        this.setState(change);
    };

    async componentDidMount() {
        await fetch(global.variables.API_TEMPLATEFILLER_GETANSWERS, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                operation: "GetExpostMq",
                missionId: this.state.missionId,
                templateId: this.state.templateId
            })
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.saveddata.length > 0) {
                    this.setState({ pageLoadData: JSON.parse(result.saveddata[0].TemplateAnswers) });

                    if (JSON.parse(result.saveddata[0].TemplateAnswers).countOtherDocuments !== undefined &&
                        JSON.parse(result.saveddata[0].TemplateAnswers).countOtherDocuments > 0) {
                        this.setState({
                            countOtherDocuments: JSON.parse(result.saveddata[0].TemplateAnswers).countOtherDocuments,
                        });
                    } else {
                        this.setState({
                            countOtherDocuments: 1,
                        });
                    }

                    if (JSON.parse(result.saveddata[0].TemplateAnswers).countPerson !== undefined &&
                        JSON.parse(result.saveddata[0].TemplateAnswers).countPerson > 0) {
                        this.setState({
                            countPerson: JSON.parse(result.saveddata[0].TemplateAnswers).countPerson,
                        });
                    } else {
                        this.setState({
                            countPerson: 1,
                        });
                    }
                }
            });

        this.props.propUpdatePageLoadData(this.state.pageLoadData);
    }

    checkIfChecked = (element, value) => {
        if (element === value) {
            return true;
        } else {
            return false;
        }
    };

    incrementOtherDocuments = () => {
        var countOtherDocuments = this.state.countOtherDocuments;

        if (countOtherDocuments < 20) {
            countOtherDocuments += 1;
        }

        this.setState({ countOtherDocuments: countOtherDocuments });
    }

    incrementPerson = () => {
        var countPerson = this.state.countPerson;

        if (countPerson < 20) {
            countPerson += 1;
        }

        this.setState({ countPerson: countPerson });
    }

    handleSelectChange = async (e, v, vname) => {
        e.persist();

        if (v !== undefined & v !== null) {
            await this.setState({ [vname]: v.TypeId });
        } else {
            await this.setState({ [vname]: -1 });
        }

        //console.log(vname + ": " + e.target.value);
        console.log(this.state);
    }

    handleSelectChangeUseValue = async (e, v, vname) => {
        e.persist();

        //console.log(data)
        //this.setState({ lastOnChange: { name, data, change } })

        var pageLoadDataChange = this.state.pageLoadData;
        //pageLoadDataChange[vname] = v.TypeName;
        if (v !== undefined & v !== null) {
            pageLoadDataChange[vname] = v.TypeId;
        } else {
            pageLoadDataChange[vname] = -1;
        }

        this.setState({
            //lastOnChange: { name, data, change },
            pageLoadData: pageLoadDataChange
        });

        //if (v !== undefined & v !== null) {
        //    await this.setState({ [vname]: v.TypeName });
        //} else {
        //    await this.setState({ [vname]: "" });
        //}

        console.log(this.state);
    }

    handleSelectChangePageLoadData = async (e, v, vname) => {

        //console.log("handleSelectChangePageLoadData vId: " + v.TypeId + " vName: " + v.TypeName + " vname: " + vname);

        e.persist();

        //console.log(data)
        //this.setState({ lastOnChange: { name, data, change } })

        var pageLoadDataChange = this.state.pageLoadData;
        //pageLoadDataChange[vname] = v.TypeName;
        if (v !== undefined & v !== null) {
            //pageLoadDataChange[vname] = v.TypeId;
            pageLoadDataChange[vname] = v.TypeName;
        } else {
            pageLoadDataChange[vname] = -1;
        }

        this.setState({
            //lastOnChange: { name, data, change },
            pageLoadData: pageLoadDataChange
        });

        console.log(this.state);
    }

    returnArrayElement = (array, element) => {
        for (var i = 0; i < array.length; i++) {
            if (array[i].TypeId === element) {
                return array[i];
            }
        }

        return ({ TypeId: "", TypeName: "" });
    };

    returnArrayElementUseValue = (array, element) => {
        for (var i = 0; i < array.length; i++) {
            if (array[i].TypeName === element) {
                return array[i];
            }
        }

        return ({ TypeId: "", TypeName: "" });
    };

    render() {
        let {
            trim,
            trimOnSubmit,
            pageLoadData,
            countOtherDocuments,
            countPerson,
            interviewPersonCategories,
        } = this.state;
        return (
            <Grid container>
                <AutoForm
                    onSubmit={this._onSubmit}
                    onChange={this._onChange}
                    trim={!!trim}
                    trimOnSubmit={!!trimOnSubmit}
                    style={{ width: "100%" }}
                >
                    <Grid item xs={12}>

                        <p>Scoring</p>
                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>Relevance</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmwS1Relevance" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmwS1Relevance, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmwS1Relevance, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmwS1Relevance, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>Efficiency</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmwS2Efficiency" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmwS2Efficiency, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmwS2Efficiency, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmwS2Efficiency, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>Effectiveness</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmwS3Effectiveness" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmwS3Effectiveness, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmwS3Effectiveness, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmwS3Effectiveness, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        {
                            //<ExpansionPanel style={{ width: "50%" }}>
                            //    <ExpansionPanelSummary
                            //        expandIcon={<ExpandMoreIcon />}
                            //        aria-controls="panel1a-content"
                            //        id="panel1a-header"
                            //    >
                            //        <Typography>Impact</Typography>
                            //    </ExpansionPanelSummary>
                            //    <ExpansionPanelDetails>
                            //        <RadioGroup aria-label="gender" name="OmwS4Impact" >
                            //            <Grid item xs direction="column">
                            //                <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmwS4Impact, "1")} control={<Radio />} className="green" />
                            //                <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmwS4Impact, "2")} control={<Radio />} className="orange" />
                            //                <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmwS4Impact, "3")} control={<Radio />} className="red" />
                            //            </Grid>
                            //        </RadioGroup>
                            //    </ExpansionPanelDetails>
                            //</ExpansionPanel>
                        }

                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>Sustainability</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmwS5Sustainability" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmwS5Sustainability, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmwS5Sustainability, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmwS5Sustainability, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>



                        <br />
                        <p>1. Relevance</p>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>
                                    1.1 Are the works contract clearly identified meeting the needs of the target groups?
                                </Typography>
                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmwQ1Are"
                                        rows={6}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmwQ1Are}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>
                                    1.2 Is the beneficiary involved in the definition of the works
                                    component?
                                </Typography>
                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmwQ2Is"
                                        rows={6}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmwQ2Is}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>1.3 Define the type of works provided. </Typography>
                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmwQ3Define"
                                        rows={6}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmwQ3Define}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>
                                    1.4a Have indicators been defined to measure the delivery of the works component?
                                </Typography>
                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmwQ4Are"
                                        rows={6}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmwQ4Are}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>
                                    1.4b Are all related data available on the tendering, evaluation
                                    and provision of works component?
                </Typography>
                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmwQ4Are2"
                                        rows={6}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmwQ4Are2}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <br />
                        <p>2. Efficiency</p>

                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>
                                    2.1 Does the works component funded by the action correspond to
                                    the needs of the action?
                </Typography>
                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmwQ5Does"
                                        rows={6}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmwQ5Does}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>
                                    2.2 Has there been delays and how important are they and what are
                                    the consequences on the project?
                                </Typography>
                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmwQ6Has"
                                        rows={6}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmwQ6Has}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>
                                    2.3 What are the reasons for the delays and to what extent have
                                    appropriate corrective measures been implemented?
                                </Typography>
                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmwQ7What"
                                        rows={6}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmwQ7What}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <br />
                        <p>3. Effectiveness</p>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>
                                    3.1 How satisfactory is the quality of the works in relation to
                                    target groups?
                                </Typography>
                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmwQ8How"
                                        rows={6}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmwQ8How}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <br />
                        <p>4. Sustainability</p>

                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>
                                    4.1 Are key stakeholders acquiring the necessary skills to benefit
                                    from the Work’s component?
                                </Typography>
                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmwQ9Are"
                                        rows={6}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmwQ9Are}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>
                                    4.2 Is access to the benefits affordable for target groups in the
                                    long term?
                </Typography>
                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmwQ10Is"
                                        rows={6}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmwQ10Is}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>
                                    4.3 Have the relevant authorities taken the financial measure(s)
                                    to ensure continuity of maintaining the works component at the
                                    end of the intervention?
                                </Typography>
                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmwQ11Have"
                                        rows={6}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmwQ11Have}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>
                                    4.4 Has the private sector been involved in any stage of the works
                                    component? If so, please state involvement
                </Typography>
                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmwQ12Has"
                                        rows={6}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmwQ12Has}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>
                                    4.5 Have the necessary measures been taken to address the
                                    environmental sustainability?
                                </Typography>
                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmwQ13Have"
                                        rows={6}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmwQ13Have}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>


                        <br />
                        <p>5. Horizontal</p>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>
                                    5.1 Have the communication and visibility actions been implemented
                                    in an appropriate manner?
                                </Typography>
                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmwQ14Have"
                                        rows={6}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmwQ14Have}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>
                                    5.2 Is the works’ component in line with the requirements of the
                                    other components of the current project (if applicable)?
                </Typography>
                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmwQ15Is"
                                        rows={6}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmwQ15Is}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>



                        <br />
                        <br />
                        <p><b>Sources of Information: List all documents analysed</b></p>
                        <p>Essential Project/Programme documents</p>

                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >Action Documents</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmwC1ProjectDocuments" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmwC1ProjectDocuments, "1")} control={<Radio />} label="Yes" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmwC1ProjectDocuments, "2")} control={<Radio />} label="No" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmwC1ProjectDocuments, "3")} control={<Radio />} label="N/A" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >Financing/Contribution/Delegation/Administration Agreement or grant contract</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                In these documents, all annexes are to be included such as Technical and Administrative provisions, Implementation schedule, logframe (incl. updates)
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmwC2FinancingContribution" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmwC2FinancingContribution, "1")} control={<Radio />} label="Yes" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmwC2FinancingContribution, "2")} control={<Radio />} label="No" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmwC2FinancingContribution, "3")} control={<Radio />} label="N/A" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >Riders to all the documents listed above and their explanatory notes</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmwC3Riders" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmwC3Riders, "1")} control={<Radio />} label="Yes" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmwC3Riders, "2")} control={<Radio />} label="No" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmwC3Riders, "3")} control={<Radio />} label="N/A" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >Annual and overall activity schedules/implementation plans</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmwC4Annual" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmwC4Annual, "1")} control={<Radio />} label="Yes" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmwC4Annual, "2")} control={<Radio />} label="No" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmwC4Annual, "3")} control={<Radio />} label="N/A" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >Implementation progress reports</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmwC5Implementation" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmwC5Implementation, "1")} control={<Radio />} label="Yes" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmwC5Implementation, "2")} control={<Radio />} label="No" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmwC5Implementation, "3")} control={<Radio />} label="N/A" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>


                        <br />
                        <p>Other Documents</p>

                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2a-content"
                                id="panel2a-header"
                            >
                                <Typography>Other Documents</Typography>
                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 0 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmwOtherDocumentsD1" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 0 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmwOtherDocumentsD1} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 1 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmwOtherDocumentsD2" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 1 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmwOtherDocumentsD2} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 2 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmwOtherDocumentsD3" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 2 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmwOtherDocumentsD3} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 3 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmwOtherDocumentsD4" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 3 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmwOtherDocumentsD4} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 4 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmwOtherDocumentsD5" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 4 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmwOtherDocumentsD5} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 5 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmwOtherDocumentsD6" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 5 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmwOtherDocumentsD6} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 6 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmwOtherDocumentsD7" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 6 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmwOtherDocumentsD7} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 7 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmwOtherDocumentsD8" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 7 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmwOtherDocumentsD8} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 8 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmwOtherDocumentsD9" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 8 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmwOtherDocumentsD9} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 9 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmwOtherDocumentsD10" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 9 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmwOtherDocumentsD10} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 10 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmwOtherDocumentsD11" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 10 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmwOtherDocumentsD11} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 11 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmwOtherDocumentsD12" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 11 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmwOtherDocumentsD12} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 12 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmwOtherDocumentsD13" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 12 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmwOtherDocumentsD13} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 13 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmwOtherDocumentsD14" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 13 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmwOtherDocumentsD14} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 14 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmwOtherDocumentsD15" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 14 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmwOtherDocumentsD15} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 15 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmwOtherDocumentsD16" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 15 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmwOtherDocumentsD16} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 16 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmwOtherDocumentsD17" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 16 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmwOtherDocumentsD17} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 17 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmwOtherDocumentsD18" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 17 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmwOtherDocumentsD18} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 18 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmwOtherDocumentsD19" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 18 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmwOtherDocumentsD19} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 19 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmwOtherDocumentsD20" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 19 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmwOtherDocumentsD20} />
                                </Grid>
                            </ExpansionPanelDetails>

                            <ExpansionPanelDetails>
                                <Grid item xs>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={this.incrementOtherDocuments.bind(this)}
                                    >
                                        Add Documents
                                </Button>
                                </Grid>
                            </ExpansionPanelDetails>

                        </ExpansionPanel>


                        <br />
                        <p><b>Sources of Information: List of persons interviewed</b></p>

                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2a-content"
                                id="panel2a-header"
                            >
                                <Typography>List Of Persons Interviewed</Typography>
                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails style={{ display: countPerson > 0 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmwSOIP1PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmwSOIP1PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmwSOIP1PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP1PersonName"
                                    value={pageLoadData.OmwSOIP1PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP1PersonEmail"
                                    value={pageLoadData.OmwSOIP1PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP1PersonPosition"
                                    value={pageLoadData.OmwSOIP1PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP1PersonInstitution"
                                    value={pageLoadData.OmwSOIP1PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 1 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmwSOIP2PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmwSOIP2PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmwSOIP2PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP2PersonName"
                                    value={pageLoadData.OmwSOIP2PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP2PersonEmail"
                                    value={pageLoadData.OmwSOIP2PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP2PersonPosition"
                                    value={pageLoadData.OmwSOIP2PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP2PersonInstitution"
                                    value={pageLoadData.OmwSOIP2PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 2 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmwSOIP3PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmwSOIP3PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmwSOIP3PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP3PersonName"
                                    value={pageLoadData.OmwSOIP3PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP3PersonEmail"
                                    value={pageLoadData.OmwSOIP3PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP3PersonPosition"
                                    value={pageLoadData.OmwSOIP3PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP3PersonInstitution"
                                    value={pageLoadData.OmwSOIP3PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 3 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmwSOIP4PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmwSOIP4PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmwSOIP4PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP4PersonName"
                                    value={pageLoadData.OmwSOIP4PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP4PersonEmail"
                                    value={pageLoadData.OmwSOIP4PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP4PersonPosition"
                                    value={pageLoadData.OmwSOIP4PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP4PersonInstitution"
                                    value={pageLoadData.OmwSOIP4PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 4 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmwSOIP5PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmwSOIP5PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmwSOIP5PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP5PersonName"
                                    value={pageLoadData.OmwSOIP5PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP5PersonEmail"
                                    value={pageLoadData.OmwSOIP5PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP5PersonPosition"
                                    value={pageLoadData.OmwSOIP5PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP5PersonInstitution"
                                    value={pageLoadData.OmwSOIP5PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 5 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmwSOIP6PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmwSOIP6PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmwSOIP6PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP6PersonName"
                                    value={pageLoadData.OmwSOIP6PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP6PersonEmail"
                                    value={pageLoadData.OmwSOIP6PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP6PersonPosition"
                                    value={pageLoadData.OmwSOIP6PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP6PersonInstitution"
                                    value={pageLoadData.OmwSOIP6PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 6 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmwSOIP7PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmwSOIP7PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmwSOIP7PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP7PersonName"
                                    value={pageLoadData.OmwSOIP7PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP7PersonEmail"
                                    value={pageLoadData.OmwSOIP7PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP7PersonPosition"
                                    value={pageLoadData.OmwSOIP7PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP7PersonInstitution"
                                    value={pageLoadData.OmwSOIP7PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 7 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmwSOIP8PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmwSOIP8PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmwSOIP8PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP8PersonName"
                                    value={pageLoadData.OmwSOIP8PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP8PersonEmail"
                                    value={pageLoadData.OmwSOIP8PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP8PersonPosition"
                                    value={pageLoadData.OmwSOIP8PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP8PersonInstitution"
                                    value={pageLoadData.OmwSOIP8PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 8 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmwSOIP9PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmwSOIP9PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmwSOIP9PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP9PersonName"
                                    value={pageLoadData.OmwSOIP9PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP9PersonEmail"
                                    value={pageLoadData.OmwSOIP9PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP9PersonPosition"
                                    value={pageLoadData.OmwSOIP9PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP9PersonInstitution"
                                    value={pageLoadData.OmwSOIP9PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 9 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmwSOIP10PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmwSOIP10PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmwSOIP10PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP10PersonName"
                                    value={pageLoadData.OmwSOIP10PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP10PersonEmail"
                                    value={pageLoadData.OmwSOIP10PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP10PersonPosition"
                                    value={pageLoadData.OmwSOIP10PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP10PersonInstitution"
                                    value={pageLoadData.OmwSOIP10PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 10 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmwSOIP11PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmwSOIP11PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmwSOIP11PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP11PersonName"
                                    value={pageLoadData.OmwSOIP11PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP11PersonEmail"
                                    value={pageLoadData.OmwSOIP11PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP11PersonPosition"
                                    value={pageLoadData.OmwSOIP11PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP11PersonInstitution"
                                    value={pageLoadData.OmwSOIP11PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 11 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmwSOIP12PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmwSOIP12PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmwSOIP12PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP12PersonName"
                                    value={pageLoadData.OmwSOIP12PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP12PersonEmail"
                                    value={pageLoadData.OmwSOIP12PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP12PersonPosition"
                                    value={pageLoadData.OmwSOIP12PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP12PersonInstitution"
                                    value={pageLoadData.OmwSOIP12PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 12 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmwSOIP13PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmwSOIP13PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmwSOIP13PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP13PersonName"
                                    value={pageLoadData.OmwSOIP13PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP13PersonEmail"
                                    value={pageLoadData.OmwSOIP13PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP13PersonPosition"
                                    value={pageLoadData.OmwSOIP13PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP13PersonInstitution"
                                    value={pageLoadData.OmwSOIP13PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 13 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmwSOIP14PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmwSOIP14PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmwSOIP14PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP14PersonName"
                                    value={pageLoadData.OmwSOIP14PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP14PersonEmail"
                                    value={pageLoadData.OmwSOIP14PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP14PersonPosition"
                                    value={pageLoadData.OmwSOIP14PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP14PersonInstitution"
                                    value={pageLoadData.OmwSOIP14PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 14 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmwSOIP15PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmwSOIP15PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmwSOIP15PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP15PersonName"
                                    value={pageLoadData.OmwSOIP15PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP15PersonEmail"
                                    value={pageLoadData.OmwSOIP15PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP15PersonPosition"
                                    value={pageLoadData.OmwSOIP15PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP15PersonInstitution"
                                    value={pageLoadData.OmwSOIP15PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 15 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmwSOIP16PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmwSOIP16PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmwSOIP16PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP16PersonName"
                                    value={pageLoadData.OmwSOIP16PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP16PersonEmail"
                                    value={pageLoadData.OmwSOIP16PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP16PersonPosition"
                                    value={pageLoadData.OmwSOIP16PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP16PersonInstitution"
                                    value={pageLoadData.OmwSOIP16PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 16 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmwSOIP17PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmwSOIP17PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmwSOIP17PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP17PersonName"
                                    value={pageLoadData.OmwSOIP17PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP17PersonEmail"
                                    value={pageLoadData.OmwSOIP17PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP17PersonPosition"
                                    value={pageLoadData.OmwSOIP17PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP17PersonInstitution"
                                    value={pageLoadData.OmwSOIP17PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 17 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmwSOIP18PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmwSOIP18PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmwSOIP18PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP18PersonName"
                                    value={pageLoadData.OmwSOIP18PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP18PersonEmail"
                                    value={pageLoadData.OmwSOIP18PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP18PersonPosition"
                                    value={pageLoadData.OmwSOIP18PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP18PersonInstitution"
                                    value={pageLoadData.OmwSOIP18PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 18 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmwSOIP19PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmwSOIP19PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmwSOIP19PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP19PersonName"
                                    value={pageLoadData.OmwSOIP19PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP19PersonEmail"
                                    value={pageLoadData.OmwSOIP19PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP19PersonPosition"
                                    value={pageLoadData.OmwSOIP19PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP19PersonInstitution"
                                    value={pageLoadData.OmwSOIP19PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 19 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmwSOIP20PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmwSOIP20PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmwSOIP20PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP20PersonName"
                                    value={pageLoadData.OmwSOIP20PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP20PersonEmail"
                                    value={pageLoadData.OmwSOIP20PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP20PersonPosition"
                                    value={pageLoadData.OmwSOIP20PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmwSOIP20PersonInstitution"
                                    value={pageLoadData.OmwSOIP20PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>

                            <ExpansionPanelDetails>
                                <Grid item xs>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={this.incrementPerson.bind(this)}
                                    >
                                        Add Person
                                </Button>
                                </Grid>
                            </ExpansionPanelDetails>

                        </ExpansionPanel>



                    </Grid>
                    <Grid item xs={12} style={{ textAlign: "center" }} className="mt-1">
                        <Button
                            variant="contained"
                            color="primary"
                            type="submit"
                        >
                            SAVE
            </Button>
                    </Grid>
                </AutoForm>
            </Grid>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/O_MonitoringNoteWorks.js